import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({}).set('Search', new Immutable.List([])).set('Response', new Immutable.Map({})).set('Get', new Immutable.Map({}))

/* Types */

export const ACTION_SEARCH_DONOR = 'ACTION_SEARCH_DONOR'

export const ACTION_GET_DONOR = 'ACTION_GET_DONOR'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case ACTION_SEARCH_DONOR:
			return state.set('Search', new Immutable.List(action.Obj))
		case ACTION_GET_DONOR:
			return state.set('Get', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const newDonor = (form) => {

	let temp = Object.assign({}, form)

	temp.legalRepresentatives = Utils.getListPropsOmit(temp.legalRepresentatives, ['id', 'tmp'])
	temp.legalRepresentatives = Utils.unionArray(temp.legalRepresentatives, temp.legalRepresentativesRemove)
	temp.legalRepresentatives = temp.legalRepresentatives.map((r) => {
		return {
			...r,
			fechaFolio: Utils.formatDate(r.fechaFolio),
			fechaEscritura: Utils.formatDate(r.fechaEscritura),
			periodoDesde: Utils.formatDate(r.periodoDesde),
			periodoHasta: Utils.formatDate(r.periodoHasta)
		}
	})

	temp.employersAdvisers = Utils.getListPropsOmit(temp.employersAdvisers, ['id', 'tmp'])
	temp.employersAdvisers = Utils.unionArray(temp.employersAdvisers, temp.employersAdvisersRemove)

	temp.contacts = Utils.getListPropsOmit(temp.contacts, ['id', 'tmp', 'cfullname'])
	temp.contacts = Utils.unionArray(temp.contacts, temp.contactsRemove)

	let obj = {
		id: temp.idDonor || undefined,
		actaConstitutiva: {
			apellidoMaternoNotario: temp.notaryLastname,
			apellidoPaternoNotario: temp.notarySurname,
			fechaEscritura: Utils.formatDate(temp.writingDate),
			fechaFolioRPP: Utils.formatDate(temp.folioDate),
			folioRPP: temp.folioRPP,
			idEstado: temp.writingState,
			nombreNotario: temp.notaryName,
			numeroEscritura: temp.writingNumber,
			numeroNotaria: temp.notaryNumber
		},
		actividadSocial: temp.socialActivity,
		cluni: temp.cluni || '',
		contactos: temp.contacts,
		deleted: temp.status === 1 ? false : true,
		createdBy: sessionStorage.uid,
		estatus: '1',
		documentos: [],
		domicilioCorrespondencia: {
			calle: temp.toggle ? temp.streetFiscal : temp.street,
			entreCalle1: temp.toggle ? temp.bstreet1Fiscal : temp.bstreet1,
			entreCalle2: temp.toggle ? temp.bstreet2Fiscal : temp.bstreet2,
			idCiudad: temp.toggle ? temp.cityFiscal : temp.city,
			idCodigoPostal: temp.toggle ? temp.cpFiscal : temp.cp,
			idColonia: temp.toggle ? temp.colonyFiscal : temp.colony,
			idEstado: temp.toggle ? temp.stateFiscal : temp.state,
			idMunicipioDelegacion: temp.toggle ? temp.townFiscal : temp.town,
			numeroExterior: temp.toggle ? temp.numextFiscal : temp.numext,
			numeroInterior: temp.toggle ? temp.numintFiscal : temp.numint,
			referencia: temp.toggle ? temp.referenceFiscal : temp.reference,
		},
		domicilioCorrespondenciaNoEsMismo: temp.toggle ? true : false,
		domicilioFiscal: {
			calle: temp.street,
			entreCalle1: temp.bstreet1,
			entreCalle2: temp.bstreet2,
			idCiudad: temp.city,
			idCodigoPostal: temp.cp,
			idColonia: temp.colony,
			idEstado: temp.state,
			idMunicipioDelegacion: temp.town,
			numeroExterior: temp.numext,
			numeroInterior: temp.numint || '',
			referencia: temp.reference
		},
		email: temp.donorEmail || '',
		fechaConstitucion: Utils.formatDate(temp.constDate),
		fechaInicioOperacion: Utils.formatDate(temp.opDate),
		idOrganismoRegulador: temp.jap,
		idPersonalidadJuridica: temp.legalPersonality,
		nombreInstitucion: temp.donorName,
		objetoSocial: temp.socialGoal,
		paginaWeb: temp.donorWebsite || '',
		patronosConsejeros: temp.employersAdvisers,
		representantesLegales: temp.legalRepresentatives,
		rfc: temp.rfc,
		telefono: temp.donorPhone
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/newDonor',
			method: "POST",
			data: { ...obj },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const searchDonor = (form) => {

	Utils.clearNullAndEmpty(form)

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: Object.keys(form).length == 0 ? 'api/searchDonor' : 'api/searchDonorParam',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_SEARCH_DONOR, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getDonor = (id) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getDonor',
			method: "POST",
			data: { id },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {

			const data = response.data

			let domicilioFiscal = data.domicilioFiscal
			let domicilioCorrespondencia = data.domicilioCorrespondencia
			let domicilioCorrespondenciaNoEsMismo = data.domicilioCorrespondenciaNoEsMismo
			let actaConstitutiva = data.actaConstitutiva
			let documentosDonante = []
			let logoDonante

			if (data.documentosDonante) {
				data.documentosDonante.forEach((d) => {

					let documentObj = {
						id: d.idDocumento,
						nombre: decodeURI(d.nombre),
						descripcion: d.descripcion,
						documento: {
							idDocumento: d.dropboxId
						}
					}

					if (d.tipoDocumento) {
						logoDonante = d.dropboxId
					} else {
						documentosDonante.push(documentObj)
					}
				})
			}

			let representantesLegales = data.representantesLegales ? data.representantesLegales.map((r) => {
				return { ...r, rep: `${r.nombre} ${r.apellidoPaterno} ${r.apellidoMaterno}` }
			}) : new Array

			let patronosConsejeros = data.patronosConsejeros ? data.patronosConsejeros.map((p) => {
				return { ...p, empfullname: `${p.nombre} ${p.apellidoPaterno} ${p.apellidoMaterno}` }
			}) : new Array

			let contactos = data.contactos ? data.contactos.map((c) => {
				return { ...c, cfullname: `${c.nombre} ${c.apellidoPaterno} ${c.apellidoMaterno}` }
			}) : new Array

			let obj = {
				idDonor: data.id,
				donorName: data.nombreInstitucion || '',
				legalPersonality: data.idPersonalidadJuridica || '',
				status: data.deleted ? 2 : 1,
				rfc: data.rfc || '',
				cluni: data.cluni || '',
				constDate: data.fechaConstitucion || '',
				opDate: data.fechaInicioOperacion || '',
				jap: data.idOrganismoRegulador || '',
				donorPhone: data.telefono || '',
				donorEmail: data.email || '',
				donorWebsite: data.paginaWeb || '',
				cp: domicilioFiscal.idCodigoPostal,
				state: domicilioFiscal.idEstado,
				town: domicilioFiscal.idMunicipioDelegacion,
				city: domicilioFiscal.idCiudad,
				colony: domicilioFiscal.idColonia,
				street: domicilioFiscal.calle,
				numext: domicilioFiscal.numeroExterior,
				numint: domicilioFiscal.numeroInterior || '',
				bstreet1: domicilioFiscal.entreCalle1,
				bstreet2: domicilioFiscal.entreCalle2,
				reference: domicilioFiscal.referencia,
				toggle: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondenciaNoEsMismo : false,
				cpFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idCodigoPostal : '',
				stateFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idEstado : '',
				townFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idMunicipioDelegacion : '',
				cityFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idCiudad : '',
				colonyFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idColonia : '',
				streetFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.calle : '',
				numextFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.numeroExterior : '',
				numintFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.numeroInterior : '',
				bstreet1Fiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.entreCalle1 : '',
				bstreet2Fiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.entreCalle2 : '',
				referenceFiscal: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.referencia : '',
				socialActivity: data.actividadSocial,
				socialGoal: data.objetoSocial || '',
				writingNumber: actaConstitutiva.numeroEscritura || '',
				writingDate: actaConstitutiva.fechaEscritura || '',
				notaryNumber: actaConstitutiva.numeroNotaria || '',
				writingState: actaConstitutiva.idEstado || '',
				notaryName: actaConstitutiva.nombreNotario || '',
				notaryLastname: actaConstitutiva.apellidoPaternoNotario || '',
				notarySurname: actaConstitutiva.apellidoMaternoNotario || '',
				folioRPP: actaConstitutiva.folioRPP || '',
				folioDate: actaConstitutiva.fechaFolioRPP || '',
				legalRepresentatives: representantesLegales,
				employersAdvisers: patronosConsejeros,
				contacts: contactos,
				documents: documentosDonante,
				logoDonante
			}

			dispatch({ type: ACTION_GET_DONOR, Obj: obj })
			dispatch(isLoading(false))
			return obj
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateDonor = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/updateDonor',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then((response) => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const clearDonor = () => {
	return (dispatch) => {
		dispatch({ type: ACTION_GET_DONOR, Obj: {} })
		dispatch({ type: ACTION_SEARCH_DONOR, Obj: [] })
	}
}



// WEBPACK FOOTER //
// ./src/modules/Catalogs/Donor/Donor.js